export class SapPlantFeatureFlags {

  public colt: boolean;
  public multiDelivery: boolean;
  public multiCollection: boolean;
  public dropAndHook: boolean;
  public tipAndReload: boolean;
  public collectionDate: boolean;
  public subcontractor: boolean;
  public kioskAtEntrance: boolean;
  public kioskAtExit: boolean;
  public unauthorizedReturns: boolean;
  public passThrough: boolean;
  public entranceCodeExpiration: number;
  public exitCodeExpiration: number;
  public covidSurvey: boolean;
  public captureSignatures: boolean;
  public bolGenerationActivated: boolean;
  public driverIdRequiredOnCustomerLocations: boolean;
  public customerIdRequiredOnCustomerLocations: boolean;
  public ymsActive: boolean;
  public paperless = false;
  public haulierNameOptional = false;
  public haulierAddressOptional = false;
  public haulierVatNumberOptional = false;
  public trailerIdOptional = true;
  public remitoRequired = false;
  public issueMaxQty: number;
  public returnMaxQty: number;
  public loadMaxQty: number;
  public unloadMaxQty: number;
  public issueAndUnauthorizedReturn = false;
  public adjustQuantitiesForCollection = false;
  public displayDeclarationText = false;

  static fromDto(data: any): SapPlantFeatureFlags {
    const configuration = new SapPlantFeatureFlags();

    if (!data) {
      return null;
    }

    configuration.colt                                  = data.colt;
    configuration.multiDelivery                         = data.multi_delivery;
    configuration.multiCollection                       = data.multi_collection;
    configuration.dropAndHook                           = data.drop_and_hook;
    configuration.tipAndReload                          = data.tip_and_reload;
    configuration.collectionDate                        = data.collection_date;
    configuration.subcontractor                         = data.subcontractor;
    configuration.kioskAtEntrance                       = data.kiosk_at_entrance;
    configuration.kioskAtExit                           = data.kiosk_at_exit;
    configuration.unauthorizedReturns                   = data.unauthorized_returns;
    configuration.passThrough                           = data.pass_through;
    configuration.entranceCodeExpiration                = data.entrance_code_expiration;
    configuration.exitCodeExpiration                    = data.exit_code_expiration;
    configuration.covidSurvey                           = data.covid_survey;
    configuration.captureSignatures                     = data.capture_signatures;
    configuration.bolGenerationActivated                = data.bol_generation_activated;
    configuration.driverIdRequiredOnCustomerLocations   = data.driver_id_required_on_customer_locations;
    configuration.customerIdRequiredOnCustomerLocations = data.customer_id_required_on_customer_locations;
    configuration.ymsActive                             = data.yms_active;
    configuration.paperless                             = data.paperless;
    configuration.haulierNameOptional                   = data.haulier_name_optional;
    configuration.haulierAddressOptional                = data.haulier_address_optional;
    configuration.haulierVatNumberOptional              = data.haulier_vat_number_optional;
    configuration.trailerIdOptional                     = data.trailer_id_optional;
    configuration.remitoRequired                        = data.remito_required;
    configuration.issueMaxQty                           = data.issue_max_qty;
    configuration.returnMaxQty                          = data.return_max_qty;
    configuration.loadMaxQty                            = data.load_max_qty;
    configuration.unloadMaxQty                          = data.unload_max_qty;
    configuration.issueAndUnauthorizedReturn            = data.issue_and_unauthorized_return;
    configuration.adjustQuantitiesForCollection         = data.adjust_quantities_for_collection;
    configuration.displayDeclarationText                = data.display_declaration_text;

    return configuration;
  }
}
